import {
  conditionsToFilters,
  filterbyToFilters,
  filtersToConditions,
  filtersToFilterby,
} from './filterEntities'

function resolveConfigurationFilters(configuration) {
  if (Array.isArray(configuration.filters)) return configuration.filters

  return [
    ...filterbyToFilters(configuration.filterby || {}),
    ...conditionsToFilters(configuration.conditions || []),
  ]
}

export function buildReportViewConfiguration({ config, charts, pinned = false }) {
  return {
    collection: config.collection,
    groupby: config.groupby || [],
    metrics: config.metrics || [],
    sortby: config.sortby || [],
    filters: config.filters || [],
    filterby: filtersToFilterby(config.filters || []),
    conditions: filtersToConditions(config.filters || []),
    charts: charts || [],
    pinned,
  }
}

export function isReportPinned(configuration) {
  return Boolean(configuration?.pinned)
}

export function applyReportViewConfiguration(configuration, dates, setConfig, setCharts) {
  if (!configuration) return

  setConfig(prev => ({
    ...prev,
    collection: configuration.collection || prev.collection,
    groupby: [...configuration.groupby || []],
    metrics: [...configuration.metrics || []],
    sortby: [...configuration.sortby || []],
    filters: [...resolveConfigurationFilters(configuration)],
    startDate: dates?.startDate ?? prev.startDate,
    endDate: dates?.endDate ?? prev.endDate,
  }))
  setCharts([...configuration.charts || []])
}
